/**
 * useReadinessScore — Single source of truth for readiness score.
 * Both the header (Layout.tsx) and the ReadinessScorecard use this hook
 * to ensure the displayed score is always consistent.
 */
import { useReadinessStore } from '../store/readinessStore';

interface ReadinessResult {
  /** 0–100 score */
  score: number;
  /** Progress bar color based on score */
  barColor: string;
  /** Whether score is 100 */
  isReady: boolean;
  /** Number of completed checklist items */
  completedCount: number;
  /** Total checklist items */
  totalCount: number;
}

export function useReadinessScore(): ReadinessResult {
  const { score, checklist } = useReadinessStore();

  const barColor = score >= 80 ? '#22c55e' : score >= 40 ? '#3b82f6' : '#f97316';
  const completedCount = checklist.filter(i => i.done).length;

  return {
    score,
    barColor,
    isReady: score >= 100,
    completedCount,
    totalCount: checklist.length,
  };
}
